"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7479],{

/***/ 67479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M20.5 5.2c-2-2.1-4.8-3.2-7.7-3.2-2.9 0-5.6 1.1-7.7 3.2C.9 9.5 1 16.4 5.2 20.8c.6.6 1.3 1.2 2.1 1.2.1 0 .3 0 .4-.1.9-.3 1.1-1.2 1.3-2.3.2-1.1.5-2.5 1.5-3.7h1.2c2.4 0 4.3-1.9 4.3-4.3v-2c1.3-.5 2.6-.6 3.6-.6 1.1-.1 2-.1 2.3-1 .4-.9-.4-1.8-1.4-2.8zM7 19.3c0 .1 0 .2-.1.4l-.3-.3c-1-1-1.7-2.1-2.1-3.3H8c-.6 1.1-.8 2.3-1 3.2zm4.7-5.3H4.1c-.3-2.6.5-5.4 2.4-7.4 1.7-1.7 4-2.6 6.3-2.6.4 0 .8 0 1.2.1v7.6c0 1.3-1 2.3-2.3 2.3zM16 7.5V4.6c1.2.4 2.2 1.1 3.1 2l.3.3c-.9.1-2.1.2-3.4.6z"
}), "Breakfast"));


/***/ })

}]);